<template>
    <velt-wireframe style="display:none;">
        <velt-comment-thread-wireframe variant="listen">
            <velt-comment-dialog-wireframe>
                <div class="comment-dialog-container">
                    <velt-comment-dialog-body-wireframe>
                        <velt-comment-dialog-threads-wireframe>
                            <velt-comment-dialog-thread-card-wireframe>
                                <div class="comment-header">
                                    <velt-comment-dialog-thread-card-avatar-wireframe />
                                    <velt-comment-dialog-thread-card-name-wireframe>
                                        <velt-if
                                            class="comment-header-name"
                                            condition="{comment.from.userId} === {user.userId}">
                                            <p>{{ $t('wireframes.commentThread.me') }}</p>
                                        </velt-if>
                                        <velt-if
                                            class="comment-header-name"
                                            condition="{comment.from.userId} !== {user.userId}">
                                            <p><velt-data field="comment.from.name" /></p>
                                        </velt-if>
                                    </velt-comment-dialog-thread-card-name-wireframe>
                                    <velt-comment-dialog-thread-card-time-wireframe />
                                    <velt-if condition="{annotation.context.migrated}">
                                        <pendo-icon
                                            class="comment-migrated-icon"
                                            type="open-response"
                                            size="16" />
                                    </velt-if>
                                    <div class="comment-header-status">
                                        <velt-if
                                            condition="{annotation.comments[0].commentId} === {comment.commentId} && {annotation.status.id} !== 'open'">
                                            <velt-comment-dialog-status-wireframe>
                                                <velt-comment-dialog-status-dropdown-trigger-wireframe>
                                                    <div class="comment-actions-button">
                                                        <pendo-button type="tertiary">
                                                            <velt-comment-dialog-status-dropdown-trigger-icon-wireframe />
                                                        </pendo-button>
                                                    </div>
                                                </velt-comment-dialog-status-dropdown-trigger-wireframe>
                                            </velt-comment-dialog-status-wireframe>
                                        </velt-if>
                                    </div>
                                    <div class="comment-header-actions">
                                        <velt-if condition="{annotation.comments[0].commentId} === {comment.commentId}">
                                            <velt-comment-dialog-status-wireframe>
                                                <velt-comment-dialog-status-dropdown-trigger-wireframe>
                                                    <div class="comment-actions-button">
                                                        <pendo-button type="tertiary">
                                                            <velt-comment-dialog-status-dropdown-trigger-icon-wireframe />
                                                        </pendo-button>
                                                    </div>
                                                </velt-comment-dialog-status-dropdown-trigger-wireframe>
                                            </velt-comment-dialog-status-wireframe>
                                        </velt-if>
                                        <velt-comment-dialog-toggle-reply-wireframe>
                                            <div class="comment-actions-button">
                                                <pendo-button
                                                    type="tertiary"
                                                    icon="message-circle" />
                                            </div>
                                        </velt-comment-dialog-toggle-reply-wireframe>
                                        <velt-comment-dialog-thread-card-reaction-tool-wireframe />
                                        <velt-if condition="{annotation.comments[0].commentId} === {comment.commentId}">
                                            <velt-comment-dialog-options-wireframe>
                                                <velt-comment-dialog-options-dropdown-trigger-wireframe>
                                                    <div class="comment-actions-button">
                                                        <pendo-button
                                                            type="tertiary"
                                                            icon="more-horizontal" />
                                                    </div>
                                                </velt-comment-dialog-options-dropdown-trigger-wireframe>
                                                <velt-comment-dialog-options-dropdown-content-wireframe>
                                                    <div class="comment-dialog-options-dropdown listen-dropdown">
                                                        <velt-comment-dialog-copy-link-wireframe>
                                                            <div class="pendo-multiselect-option">
                                                                <pendo-icon
                                                                    type="link"
                                                                    size="16" />
                                                                <span class="pendo-multiselect-label">{{ $t('wireframes.commentThread.copyLink') }}</span>
                                                            </div>
                                                        </velt-comment-dialog-copy-link-wireframe>
                                                        <velt-comment-dialog-options-dropdown-content-notification-wireframe>
                                                            <velt-comment-dialog-options-dropdown-content-notification-subscribe-wireframe>
                                                                <div class="pendo-multiselect-option">
                                                                    <pendo-icon
                                                                        type="bell"
                                                                        size="16" />
                                                                    <span class="pendo-multiselect-label">{{ $t('wireframes.commentThread.subscribe') }}</span>
                                                                </div>
                                                            </velt-comment-dialog-options-dropdown-content-notification-subscribe-wireframe>
                                                            <velt-comment-dialog-options-dropdown-content-notification-unsubscribe-wireframe>
                                                                <div class="pendo-multiselect-option">
                                                                    <pendo-icon
                                                                        type="bell-off"
                                                                        size="16" />
                                                                    <span class="pendo-multiselect-label">{{ $t('wireframes.commentThread.unsubscribe') }}</span>
                                                                </div>
                                                            </velt-comment-dialog-options-dropdown-content-notification-unsubscribe-wireframe>
                                                        </velt-comment-dialog-options-dropdown-content-notification-wireframe>
                                                        <velt-comment-dialog-options-dropdown-content-edit-wireframe>
                                                            <div class="pendo-multiselect-option">
                                                                <pendo-icon
                                                                    type="edit"
                                                                    size="16" />
                                                                <span class="pendo-multiselect-label">{{ $t('wireframes.commentThread.edit') }}</span>
                                                            </div>
                                                        </velt-comment-dialog-options-dropdown-content-edit-wireframe>
                                                        <velt-comment-dialog-options-dropdown-content-delete-wireframe>
                                                            <div class="pendo-multiselect-option">
                                                                <pendo-icon
                                                                    type="trash-2"
                                                                    size="16" />
                                                                <span class="pendo-multiselect-label">{{ $t('wireframes.commentThread.delete') }}</span>
                                                            </div>
                                                        </velt-comment-dialog-options-dropdown-content-delete-wireframe>
                                                    </div>
                                                </velt-comment-dialog-options-dropdown-content-wireframe>
                                            </velt-comment-dialog-options-wireframe>
                                        </velt-if>
                                        <velt-if condition="{annotation.comments[0].commentId} !== {comment.commentId}">
                                            <velt-comment-dialog-thread-card-options-wireframe>
                                                <velt-comment-dialog-options-dropdown-trigger-wireframe>
                                                    <div class="comment-actions-button">
                                                        <pendo-button
                                                            type="tertiary"
                                                            icon="more-horizontal" />
                                                    </div>
                                                </velt-comment-dialog-options-dropdown-trigger-wireframe>
                                                <velt-comment-dialog-options-dropdown-content-wireframe>
                                                    <div class="comment-dialog-options-dropdown listen-dropdown">
                                                        <velt-comment-dialog-options-dropdown-content-edit-wireframe>
                                                            <div class="pendo-multiselect-option">
                                                                <pendo-icon
                                                                    type="edit"
                                                                    size="16" />
                                                                <span class="pendo-multiselect-label">{{ $t('wireframes.commentThread.edit') }}</span>
                                                            </div>
                                                        </velt-comment-dialog-options-dropdown-content-edit-wireframe>
                                                        <velt-comment-dialog-options-dropdown-content-delete-wireframe>
                                                            <div class="pendo-multiselect-option">
                                                                <pendo-icon
                                                                    type="trash-2"
                                                                    size="16" />
                                                                <span class="pendo-multiselect-label">{{ $t('wireframes.commentThread.delete') }}</span>
                                                            </div>
                                                        </velt-comment-dialog-options-dropdown-content-delete-wireframe>
                                                    </div>
                                                </velt-comment-dialog-options-dropdown-content-wireframe>
                                            </velt-comment-dialog-thread-card-options-wireframe>
                                        </velt-if>
                                    </div>
                                </div>
                                <velt-comment-dialog-thread-card-message-wireframe />
                                <velt-comment-dialog-thread-card-reactions-wireframe />
                            </velt-comment-dialog-thread-card-wireframe>
                            <velt-comment-dialog-more-reply-wireframe />
                        </velt-comment-dialog-threads-wireframe>
                        <velt-if condition="{annotation.comments.length} > 1">
                            <velt-comment-dialog-toggle-reply-wireframe />
                        </velt-if>
                    </velt-comment-dialog-body-wireframe>
                    <velt-comment-dialog-composer-wireframe>
                        <velt-comment-dialog-composer-input-wireframe :placeholder="$t('wireframes.commentThread.replyPlaceholder')" />
                        <velt-comment-dialog-composer-action-button-wireframe type="submit" />
                    </velt-comment-dialog-composer-wireframe>
                </div>
            </velt-comment-dialog-wireframe>
        </velt-comment-thread-wireframe>
    </velt-wireframe>
</template>

<script>
import { PendoButton, PendoIcon } from '@pendo/components';

export default {
    name: 'CommentThread',
    components: {
        PendoButton,
        PendoIcon,
    },
};
</script>
